// extracted by mini-css-extract-plugin
module.exports = {"coverTable":"coverTable_coverTable__yjvR1","copy":"coverTable_copy__4bibH","table":"coverTable_table__aVr3G","value":"coverTable_value__1lRD6","title":"coverTable_title__I88Eh"};